<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Informações</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-info"></i>Credenciais de acesso</h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Nome</label>
                <input
                  v-model="user.name"
                  class="form-control"
                  placeholder="Nome"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  v-model="user.email"
                  class="form-control"
                  placeholder="E-mail"
                  @blur="(event) => {user.login = event.target.value}"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Login</label>
                <input
                  v-model="user.login"
                  class="form-control"
                  placeholder="Login"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Senha</label>
                <input
                  class="form-control"
                  type="password"
                  v-model="user.password"
                  placeholder="Senha"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p>
                <button href="#0" class="btn_1 medium pull-right" @click="changeAccess">
                  Alterar Credenciais
                </button>
              </p>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Informações da sua Operadora
            </h2>
          </div>
          <div class="row">


            <div class="col-md-8">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Nome uniodonto</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o nome da uniodonto"
                      v-model="operadora.name"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>CNPJ</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o CNPJ"
                      v-model="operadora.cnpj"
                      v-mask="['##.###.###/####-##']"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Código ANS</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o código ANS"
                      v-model="operadora.ans"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Email notificação de vendas</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o e-mail que irá receber as notifcações de vendas"
                      v-model="operadora.email"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Telefone de Contato</label>
                    <input
                      class="form-control"
                      v-model="operadora.telefone"
                      type="text"
                      placeholder="Telefone"
                      v-mask="['(##) #####-####','(##) ####-####']"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Logo uniodonto</label>
                <input
                  type="file"
                  class="form-control"
                  placeholder="Informe a foto"
                  @change="trocaFoto"
                />
              </div>
              <img :src="imagem_foto" class="img-thumbnail" />
            </div>
          </div>

          <div class="row">

            
            <div class="col-md-12">
              <div class="form-group">
                <label>Descrição Pós-Vendas</label>
                <vue-editor
                  v-model="operadora.texto_email_pos_venda"
                  :editorToolbar="customToolbar"
                  placeholder="Aqui você deve preencher com o conteúdo, que será mostrado no e-mail de fechamento da compra. O mesmo texto será mostrado na página de fechamento do pedido"
                ></vue-editor>
              </div>
            </div>
            <!--<div class="col-md-12">
              <div class="form-group">
                <label>Informações Gerais</label>
                <p>Aqui você pode descrever detalhes sobre sua operadora:</p>
                <vue-editor v-model="operadora.descricao_operadora" :editorToolbar="customToolbar"></vue-editor>
              </div>
            </div>-->
          </div>
          <div class="row">
            <div class="col-md-12" v-if="erroCep">
              <div class="alert alert-danger alert-dismissible" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div v-html="msgErroCep"></div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-mask="'#####-###'"
                  type="text"
                  class="form-control"
                  placeholder="XXXXX-XXX"
                  v-model="endereco.cep"
                  @blur="procuraCep()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Estado</label>
                <input type="text" class="form-control" readonly v-model="endereco.uf" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <label>Cidade</label>
                <input type="text" class="form-control" readonly v-model="endereco.localidade" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label>Bairro</label>
                <input type="text" class="form-control" v-model="endereco.bairro" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <label>Logradouro</label>
                <input type="text" class="form-control" v-model="endereco.logradouro" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Número</label>
                <input type="text" class="form-control" v-model="endereco.numero" />
              </div>
            </div>
            <div class="col-md-9">
              <div class="form-group">
                <label>Complemento</label>
                <input type="text" class="form-control" v-model="endereco.complemento" />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <p>
              <button href="#0" class="btn_1 medium pull-right" @click="editaOperadora()">Salvar</button>
            </p>
          </div>
        </div>

        <hr />
        <!-- Card de abrangência -->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-map"></i>Abrangência da sua Operadora
            </h2>
            <p>Adicione ou remova a cidade na lista abaixo</p>
          </div>
          <div class="row">
            <div class="col-md-12" v-if="erroCepAbrangencia">
              <div class="alert alert-danger alert-dismissible" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <strong>Ops!</strong>
                <span>{{msgErroCepAbrangencia}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-mask="'#####-###'"
                  type="text"
                  class="form-control"
                  placeholder="CEP cidade"
                  v-model="cepAbrangencia"
                  @blur="procuraCepAbrangencia()"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Estado</label>
                <input type="text" class="form-control" disabled v-model="estadoAbrangencia" />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label>Cidade</label>
                <input type="text" class="form-control" disabled v-model="cidadeAbrangencia" />
              </div>
            </div>
            <div class="col-md-1">
              <button href="#0" class="btn_1 mt-4" @click="addAbrangencia()">
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <div class="col-md-12">
              <ul>
                <li v-for="cidade of abrangencia" :key="cidade.id">
                  {{cidade.estado}} - {{cidade.nome}}
                  <i
                    class="fa fa-times"
                    @click="rmAbrangencia(cidade.id)"
                  ></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import { ReturnStringErrorByArrayOfErrors } from '../../../utils/util';

export default {
  components: {
    VueEditor,
    Money
  },
  mixins: [funcoesGerais],
  data() {
    return {
      cepAbrangencia: "",
      estadoAbrangencia: "",
      cidadeAbrangencia: "",
      imagem_foto: "",
      operadora: {},
      erroCep: false,
      msgErroCep: "",
      erroCepAbrangencia: false,
      msgErroCepAbrangencia: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      mostraErro: false,
      erroMensagem: "",
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
        //['image', 'code-block']
      ],
      isLoading: false,
      endereco: {
        cep: "",
        uf: "",
        localidade: "",
        logradouro: "",
        bairro: "",
        numero: "",
        complemento: ""
      },
      abrangencia: [],
      user: {
        name: "",
        email: "",
        login: "",
        password: "",
      },
    };
  },
  mounted() {
    var self = this;
    self.isLoading = true;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    ajax("get", "/operadoras/"+user.id_operadora+"/detalhes/adm")
      .then(response => {
        self.isLoading = false;
        self.endereco.cep = response.detalhes.end_cep;
        self.endereco.uf = response.detalhes.end_estado;
        self.endereco.localidade = response.detalhes.end_cidade;
        self.endereco.logradouro = response.detalhes.end_logradouro;
        self.endereco.bairro = response.detalhes.end_bairro;
        self.endereco.numero = response.detalhes.end_numero;
        self.endereco.complemento = response.detalhes.end_complemento;
        self.operadora = response.detalhes;
        self.abrangencia = response.abrangencia;
        self.imagem_foto = self.operadora.logo_src;
        self.operadora.logo_src = null;
        self.user.login = response.detalhes.users.login;
        self.user.email = response.detalhes.users.email;
        self.user.name = response.detalhes.users.name;
      })
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error, this);
      });
  },
  methods: {
    rmAbrangencia(idCidade) {
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (user) {
        self.isLoading = true;
        ajax("delete", "/cidades/" + idCidade)
          .then((response) => {
            self.isLoading = false;
            let index = self.abrangencia.findIndex(x => x.id == idCidade);
            self.abrangencia.splice(index, 1);
            alerta(
              "success",
              "Sucesso",
              "Cidade removida com sucesso!"
            );
          })
          .catch((error) => {
            self.isLoading = false;
            self.erroCepAbrangencia = true;
            self.msgErroCepAbrangencia = "Erro ao remover cidade.";
          });
      } else {
        self.$router.replace(self.$route.query.redirect || "/");
      }
    },
    addAbrangencia() {
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (user) {
        self.isLoading = true;

        if (self.cepAbrangencia) {
          var post = {
            nome: self.cidadeAbrangencia,
            estado: self.estadoAbrangencia,
            provider_id: user.id_operadora
          };

        ajax("post", "/cidades", post)
          .then(response => {
            self.isLoading = false;
            alerta(
              "success",
              "Sucesso",
              "Cidade adicionada com sucesso!"
            );
            self.abrangencia.push(response);
            self.cidadeAbrangencia = "";
            self.estadoAbrangencia = "";
            self.cepAbrangencia = "";
          })
          .catch(error => {
            self.isLoading = false;
            self.erroCepAbrangencia = true;
            self.msgErroCepAbrangencia = "Cidade ja existente";
            tratamento_requisicao(error, this);
          });
        } else {
          alert("Informe o CEP");
        }
      } else {
        self.$router.replace(self.$route.query.redirect || "/");
      }
    },
    procuraCep() {
      var self = this;
      if (self.endereco.cep.length == 9) {
        self.isLoading = true;
        self.erroCep = false;
        self.$http
          .get("https://viacep.com.br/ws/" + self.endereco.cep + "/json/")
          .then(res => res.json())
          .then(
            response => {
              self.isLoading = false;
              self.endereco = [];
              if (response.erro) {
                self.msgErroCep =
                  "<strong>Cep incorreto!</strong> Verifique o cep informado.";
                self.erroCep = true;
              } else {
                self.endereco = response;
              }
            },
            err => {
              self.isLoading = false;
              self.endereco = [];
              self.msgErroCep =
                "<strong>Erro na consulta!</strong> Tente novamente.";
              self.erroCep = true;
            }
          );
      } else {
        self.msgErroCep =
          "<strong>Cep incorreto!</strong> Verifique o cep informado.";
        self.erroCep = true;
      }
    },
    procuraCepAbrangencia() {
      var self = this;
      if (self.cepAbrangencia.length == 9) {
        self.isLoading = true;
        self.erroCepAbrangencia = false;
        self.$http
          .get("https://viacep.com.br/ws/" + self.cepAbrangencia + "/json/")
          .then(res => res.json())
          .then(
            response => {
              self.isLoading = false;
              if (response.erro) {
                self.msgErroCepAbrangencia =
                  "Cep incorreto, verifique o número informado.";
                self.erroCepAbrangencia = true;
              } else {
                self.cidadeAbrangencia = response.localidade;
                self.estadoAbrangencia = response.uf;
              }
            },
            err => {
              self.isLoading = false;
              self.endereco = [];
              self.msgErroCepAbrangencia = "Tente novamente.";
              self.erroCepAbrangencia = true;
            }
          );
      } else {
        self.msgErroCepAbrangencia =
          "Cep incorreto, verifique o número informado.";
        self.erroCepAbrangencia = true;
      }
    },
    editaOperadora() {
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (user) {
        self.isLoading = true;

        self.operadora.end_cep = self.endereco.cep;
        self.operadora.end_estado = self.endereco.uf;
        self.operadora.end_cidade = self.endereco.localidade;
        self.operadora.end_logradouro = self.endereco.logradouro;
        self.operadora.end_bairro = self.endereco.bairro;
        self.operadora.end_numero = self.endereco.numero;
        self.operadora.end_complemento = self.endereco.complemento;


        var objRequest = new FormData();
        var item = self.operadora;
        for (var key in item) {
          if (item[key]) objRequest.append(key, item[key]);
        }


        ajax("post", "/edit_operadoras/" + user.id_operadora, objRequest)
          .then(response => {
            self.isLoading = false;
            alerta(
              "success",
              "Sucesso",
              "Informações atualizadas com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            self.erroCepAbrangencia = true;
            self.msgErroCepAbrangencia = "Erro ao editar";
            tratamento_requisicao(error, this);
          });
      } else {
        self.$router.replace(self.$route.query.redirect || "/");
      }
    },
    editaInformacoes() {
      let self = this;
      self.isLoading = true;
      delete self.prestadora.foto;
      delete self.prestadora.capa;
      ajax("put", "/prestadoras/" + self.prestadora.id, self.prestadora)
        .then(response => {
          self.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Informações foram atualizadas com sucesso!"
          );
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    trocaFoto: function ($event) {
      this.operadora.logo_src = $event.target.files[0];
      this.imagem_foto = URL.createObjectURL(this.operadora.logo_src);
    },

    changeAccess() {
      let self = this;
      if(self.user.name && self.user.email && self.user.login && self.user.password) {
        self.isLoading = true;
        var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
        ajax("put", "/usuarios/"+user.id, self.user)
        .then(response => {
          self.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Credenciais de acesso foram atualizadas com sucesso!"
          );
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
      } else {
        let erros = {};
        if (!self.user.name) erros.name = ["O campo nome é obrigatório."];
        if (!self.user.email) erros.email = ["O campo email é obrigatório."];
        if (!self.user.login) erros.login = ["O campo login é obrigatório."];
        if (!self.user.password) erros.password = ["O campo senha é obrigatório."];
        alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
      }
    }
  }
};
</script>